import { render, staticRenderFns } from "./SurveyQuestionsEdit.vue?vue&type=template&id=c80586bc&scoped=true"
import script from "./SurveyQuestionsEdit.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionsEdit.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestionsEdit.vue?vue&type=style&index=0&id=c80586bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80586bc",
  null
  
)

export default component.exports